<template>  <!--年终活动总结 -->
<div class="main-body">
  <div class="main-body-search">
    <el-form :inline="true" :model="filters" @submit.native.prevent>
      <el-form-item>
        <el-select v-model="filters.orgType" placeholder="机构类别">
          <el-option
             v-for="item in residentOfficeTypes"
             :key="item.key"
             :label="item.value"
             :value="item.key">
           </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="filters.orgName" placeholder="机构名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker v-model="filters.year" type="year" placeholder="选择年份" value-format="yyyy">
        </el-date-picker>
        <!-- <el-select v-model="filters.year" filterable placeholder="选择年份">
          <el-option v-for="value in yearArray" :key="value" :label="value" :value="value"></el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="searchMain(1)">查询</el-button>
      </el-form-item>
    </el-form>
  </div>
  <el-main class="main-body-table">
    <el-table :data="mainTableData" stripe>
      <el-table-column prop="orgName" fixed  label="机构名称" align="center" width="280">
      </el-table-column>
      <el-table-column prop="year" label="年份" align="center"  width="180">
      </el-table-column>
      <el-table-column prop="filename"  label="文件名称" align="center" width="280">
      </el-table-column>
      <el-table-column prop="category" label="上传类型" align="center"  width="150">
      </el-table-column>
      <el-table-column  width="180" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="downloadAttachment(scope.row, scope.$index)">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页工具条-->
    <el-pagination class="main-body-table-page" layout="total, sizes, prev, pager, next, jumper"
      @current-change="handleCurrentChange" @size-change="handleSizeChange"
      :current-page="pager.current" :page-size="pager.size" :total="total">
    </el-pagination>
  </el-main>
  <Comp-activity-attachment
    v-if="uploadDialogVisible"
    :actionOfParent="currentAction"
    :currentTableRow="currentTableRow"
    :category = "category"
    :uploadDialogVisible.sync="uploadDialogVisible"
    @listenToDetailDialogClose="uploadDialogCloseWithModified"
  >
</Comp-activity-attachment>
</div>
</template>

<script>
import {
  findActivityAttachment,
} from '../../api/plan/PlanActivityQuery';
import {
  download
} from '@/util/http';
import CompActivityAttachment from '../../comp/plan/CompActivitySummaryAttachment';
import dateUtil from '../../../common/js/util';
export default {
  name: 'planPlanActivity',
  props: {
    // 外键约束属性
    // 来自父组件指定的标题
    cardTitle: String,
    // 来自父组件的操作类型参数
    actionOfParent: Object
  },
  components: {
    CompActivityAttachment
  },
  data() {
    return {
      residentOfficeTypes: [],
      // 主表记录总数
      total: 0,
      // 分页及查询对象
      pager: {
        current: 1,
        size: 10
      },
      // 查询过滤条件对象
      filters: {
        year: new Date().getFullYear().toString(),
        category:''
      },
      mainTableData:[],
      // 上传页面显示隐藏控制
      uploadDialogVisible:false,
      // 当前操作类型, ACTION.NEW/ACTION.EDIT/ACTION.VIEW
      currentAction: {},
      // 当前主表行记录
      currentTableRow: {},
      // 上传类型
      category:'',
    };
  },
  computed: {
    // 操作类型常量
    ACTION: function () {
      return {
        NEW: { value: 1, name: this.$t('c.table.new') },
        EDIT: { value: 2, name: this.$t('c.table.edit') },
        VIEW: { value: 3, name: this.$t('c.table.view') },
        UPLOAD: {value: 4, name: this.$t('c.table.upload') }
      }
    }
  },
  // 页面首次加载数据
  mounted() {
    this.category = this.utils.activitySummaryAttachmentType[1].key;
    // 获取当前用户可使用的机构类型
    this.residentOfficeTypes = JSON.parse(sessionStorage.getItem('dynamicResidentOfficeTypes'))
    // 默认取 - 获取当前用户可使用的机构类型第一个值
    this.filters.orgType = JSON.parse(sessionStorage.getItem('dynamicResidentOfficeTypes'))[0].key
    this.searchMain()
  },
  methods: {
    handleSizeChange(size) {
      this.pager.size = size;
      this.searchMain();
    },
    handleCurrentChange(current) {
      this.pager.current = current;
      this.searchMain();
    },

    async uploadDialog(action, row) {
      this.currentTableRow = Object.assign({}, row);
      this.currentAction = action;
      this.uploadDialogVisible = true;
    },
    // 关闭上传窗口
    uploadDialogCloseWithModified: function(action) {
      this.searchMain(1)
    },
    /**
    * 查询
    */
    searchMain(current) {
      if (current && current >= 1) {
        // 重新查询该页
        this.pager.current = current;
      }
      this.findActivityAttachment();
    },
    /**
    * 查询列表
    */
    findActivityAttachment() {
      this.mainTableData = []
      this.filters.category = this.category
      this.filters.current = this.pager.current;
      this.filters.size = this.pager.size;
      this.filters.fuzzyText = this.pager.fuzzyText;
      findActivityAttachment(this.filters).then(result => {
          if (result.code == 20000 && result.data) {
            result.data.forEach(row => {
              row.size = dateUtil.bytesToSize(row.size);
              row.namespace = "/plan"; // 前台虚拟值 为了方便文件上传下载 判断处理那种附件
              row.category =  dateUtil.findDictItemValueByItemCode(row.category, this.utils.activitySummaryAttachmentType);
            });
            this.total = result.total;
            this.mainTableData = result.data;
          }
        }).catch(() => {
        return this.$message.error(`数据查询异常`);
      });
    },
    // 文件下载
    downloadAttachment(row) {
      let json = Object.assign({}, row);
      download(row.namespace + "/summary/attachment/download", json.filename, {'id': json.id});
    },

  }
}
</script>

<style lang="scss"></style>
